import React, {Component} from 'react';
import Clipboard from 'clipboard';

export default class GenericShareableLinkBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            link: props.link
        };
    }

    componentDidMount() {
        new Clipboard('#copy-shareable-link');
    }

    displayShareLinkCallToAction() {
        const {link} = this.props;

        if (!link) {
            return (
                <a onClick={this.props.handleGetShareableLinkClick}>
                    CLICK HERE TO TURN LINK SHARING ON
                </a>
            );
        }
        return (
            <a onClick={this.props.handleRemoveShareableLinkClick}>
                CLICK HERE TO TURN LINK SHARING OFF
            </a>
        );
    }

    displayShareLink() {
        const {link} = this.props;

        if (link) {
            return (
                <div className="form-group">
                    <label>
                        <strong>Link sharing is on</strong>
                        <br />
                        Any person with this link will have access to the content.
                    </label>
                    <div className="inputs-horizontal">
                        <input className="form-control" id="shareable-link" readOnly value={link} />
                        <button
                            id="copy-shareable-link"
                            data-clipboard-target="#shareable-link"
                            className="btn btn-info"
                        >
                            COPY LINK
                        </button>
                    </div>
                </div>
            );
        }
        return (
            <div className="form-group">
                <label>
                    <strong>Link sharing is off</strong>
                </label>
            </div>
        );
    }

    render() {
        const linkCallToAction = this.displayShareLinkCallToAction();
        const shareLink = this.displayShareLink();

        return (
            <div className="generic-shareable-link-box">
                {shareLink}
                {linkCallToAction}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/share_content_modal/generic_shareable_link_box.js